'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var ContentIntroduction = function ContentIntroduction(_ref) {
  var children = _ref.children,
    className = _ref.className,
    isHTML = _ref.isHTML;
  var classes = index.default(!isHTML && 'content-introduction', className);
  return !children ? null : isHTML ? /*#__PURE__*/React__default.default.createElement("div", {
    className: classes,
    dangerouslySetInnerHTML: {
      __html: children
    }
  }) : /*#__PURE__*/React__default.default.createElement("h2", {
    className: classes
  }, children);
};
ContentIntroduction.defaultProps = {};
ContentIntroduction.propTypes = {
  children: PropTypes__default.default.node || PropTypes__default.default.string,
  className: PropTypes__default.default.string,
  isHTML: PropTypes__default.default.bool
};

exports.ContentIntroduction = ContentIntroduction;
exports.default = ContentIntroduction;
//# sourceMappingURL=ContentIntroduction.js.map
